import styled from "@emotion/styled";
import { Image } from "antd";
import { useCallback, useEffect, useState } from "react";

interface Props {
	src?: string;
	width: number;
	height: number;
	areaHeight: number;
}

export const ImageFill = (props: Props) => {
	const [width, setWidth] = useState<number | string>(props.width);
	const [height, setHeight] = useState<number>(props.height);
	const [areaHeight, setAreaHeight] = useState<number>(props.areaHeight);

	const setRem = useCallback(() => {
		const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
		const htmlHeight = (htmlWidth / props.width) * props.height;
		// If current device is mobile
		if (htmlWidth < 544){
			setWidth("100%");
			setAreaHeight(htmlHeight);
		}

		setWidth(htmlWidth);
		// 如果页面宽度大于图片宽度，拉伸高度
		setHeight(htmlHeight);
	}, [props.height, props.width]);

	useEffect(() => {
		setRem();
	}, [setRem]);

	window.onresize = () => {
		setRem();
	};

	const marginTop = () => {
		return {
			marginTop: areaHeight < height ? (areaHeight - height) / 2 + "px" : 0,
		};
	};

	return (
		<Container style={{ maxHeight: areaHeight, lineHeight: areaHeight + "px" }}>
			<Image
				width={width}
				height={height}
				style={marginTop()}
				preview={false}
				src={props.src ?? "https://optibelt.oss-cn-shanghai.aliyuncs.com/img/vhs-assets-css-60350ea6517946eebce0778e189b73bb.jpg"}
			/>
		</Container>
	);
};

const Container = styled.div`
	overflow: hidden;
	border-bottom: 4px solid #004885;
`;
